import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { io, Socket } from "socket.io-client";
import {
  fetchIssues,
  fetchDependencies,
  fetchBaselines,
} from "../../../core/data/redux/projects/thunks";
import type { AppDispatch } from "../../../core/data/redux/store";

let socket: Socket | null = null;

export const useProjectSocket = (projectId: number | null | undefined) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!projectId) return;

    if (!socket) {
      socket = io(process.env.REACT_APP_API_URL || "http://localhost:3000", {
        path: "/task-management-socket/",
        transports: ["websocket", "polling"],
      });
    }

    // Join room for this project
    socket.emit("join_project", projectId);

    const handleIssueUpdated = () => {
      dispatch(fetchIssues({ project_id: projectId }));
    };

    const handleDependenciesChanged = () => {
      dispatch(fetchDependencies(projectId));
      dispatch(fetchIssues({ project_id: projectId })); // dependencies might change dates
    };

    const handleScheduleUpdated = () => {
      dispatch(fetchIssues({ project_id: projectId }));
      dispatch(fetchDependencies(projectId));
    };

    socket.on("ISSUE_UPDATED", handleIssueUpdated);
    socket.on("ISSUE_CREATED", handleIssueUpdated);
    socket.on("ISSUE_DELETED", handleIssueUpdated);
    socket.on("DEPENDENCIES_CHANGED", handleDependenciesChanged);
    socket.on("SCHEDULE_UPDATED", handleScheduleUpdated);

    return () => {
      if (socket) {
        socket.off("ISSUE_UPDATED", handleIssueUpdated);
        socket.off("ISSUE_CREATED", handleIssueUpdated);
        socket.off("ISSUE_DELETED", handleIssueUpdated);
        socket.off("DEPENDENCIES_CHANGED", handleDependenciesChanged);
        socket.off("SCHEDULE_UPDATED", handleScheduleUpdated);
        socket.emit("leave_project", projectId);
      }
    };
  }, [projectId, dispatch]);
};
